import { devhubMakeStyles } from '@devxdiscover/devhub-ui/dist/style/devhubMakeStyles';

import GreenScoreProfileMetric from './GreenScoreProfileMetric';
import { DevHubTypography } from '@devxdiscover/devhub-ui';

interface GreenScoreComputationModalProps {
  metrics: GreenScoreProfileMetricProps[];
}

/**
 * GreenScoreComputationModal
 * @param props GreenScoreComputationModalProps
 * @returns Component
 */
function GreenScoreComputationModal(props: GreenScoreComputationModalProps) {
  const classes = devhubMakeStyles({
    metricModalGrid: {
      display: 'grid',
      gridTemplateColumns: props.metrics?.length > 1 ? '1fr 1fr' : null,
      gap: '20px',
      justifyContent: 'center',
    },
    topExplanation: {
      marginBottom: '20px',
    },
    btmExplanationTitle: {
      margin: '10px 0',
    },
  })();

  return (
    <div className={classes.metricsContainer}>
      <DevHubTypography className={classes.topExplanation} fontColor="medGray">
        This breakdown provides a structured approach to understanding how
        different operational aspects contribute to the overall Green Score of
        an application, promoting awareness and potential improvements in
        resource efficient and environmental impact reduction.
      </DevHubTypography>

      {/* Iterating over n-metrics provided by the backend to show customer what values were used in determining their Green Score  */}
      <div className={classes.metricModalGrid}>
        {props.metrics.map((metricProps: GreenScoreProfileMetricProps) => (
          <GreenScoreProfileMetric {...metricProps} />
        ))}
      </div>

      <DevHubTypography
        fontSize="large"
        weight="bold"
        fontColor="medGray"
        className={classes.btmExplanationTitle}
      >
        Interpretation
      </DevHubTypography>
      <DevHubTypography className={classes.btmExplanation} fontColor="medGray">
        This breakdown provides a structured approach to understanding how
        different operational aspects contribute to the overall Green Score of
        an application, promoting awareness and potential improvements in
        resource efficient and environmental impact reduction.
      </DevHubTypography>
    </div>
  );
}

export default GreenScoreComputationModal;
